// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header */
#claims-container .brand-name a,
#claims-container a.link {
  color: #464646;
}

#claims-container a.link:hover {
  color: #949494;
}

#claims-container img {
  color: blue;
}

/* Claims */
#claims-container {
  overflow: hidden;
}
#claims {
  position: relative;
  margin-top: 12vh;
  border-top: 1px solid #808080;
}

#claims .intro {
  padding: 2% 6%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#claims .intro .title {
  color: #464646;
  font-family: 'Cinzel', serif;
  font-size: 36px;
  margin-bottom: 45px;
  text-align: center;
}

#claims .intro img.claims-icon {
  height: 85px;
  margin-bottom: 60px;
}

#claims .intro .detail-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-around;
  margin-bottom: 60px;
}

/* break point smaller than 576*/
#claims .intro .detail-container .img-container {
  margin: 0 15px;
  width: 440px;
  height: 263px;
  display: flex;
}

#claims .intro .detail-container .img-container.first {
  background-image: url(/public/assets/icons/dots_right.png);
  background-repeat: no-repeat;
  background-size: 160px;
  background-position-x: 100%;
  align-items: flex-end;
}

#claims .intro .detail-container .img-container.second {
  background-image: url(/public/assets/icons/dots_left.png);
  background-repeat: no-repeat;
  background-size: 160px;
  align-items: flex-end;
  justify-content: flex-end;
}

#claims .intro .detail-container .img-container img {
  width: auto;
  height: 230px;
}

#claims .intro .detail-container .description-container {
  margin: 0 15px;
  width: 440px;
  display: flex;
}

#claims .intro .detail-container .description-container.second {
  justify-content: flex-end;
}

#claims .intro .detail-container .description-container p {
  margin: 30px 0;
  font-style: italic;
  font-size: 16px;
  padding: 0 20px;
  width: 380px;
}

#claims .intro .detail-container .description-container.second p {
  text-align: end;
}

#claims .claims-market {
  background-color: #f4f4f4;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 6%;
}

#claims .claims-market .title {
  color: #464646;
  font-family: 'Cinzel', serif;
  font-size: 36px;
  margin-bottom: 45px;
  text-align: center;
}

#claims .claims-market p {
  width: 68%;
  text-align: center;
  line-height: 30px;
  font-size: 16px;
  margin-bottom: 30px;
}

#claims #default-btn {
  margin-top: 15px;
}

@media (max-width: 500px) {
  #claims .intro .detail-container .description-container {
    margin: 0;
  }
  #claims .intro .detail-container .description-container p {
    width: 100%;
  }
  #claims .intro .detail-container .img-container {
    width: 315px;
    height: 188px;
    margin: 0;
  }
  #claims .intro .detail-container .img-container img {
    height: 165px;
  }
  #claims .intro .detail-container .img-container.first,
  #claims .intro .detail-container .img-container.second {
    background-size: 120px;
  }
}
`, "",{"version":3,"sources":["webpack://./client/styles/Claims.css"],"names":[],"mappings":"AAAA,WAAW;AACX;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,aAAa;AACf;;AAEA;EACE,0DAA0D;EAC1D,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,yDAAyD;EACzD,4BAA4B;EAC5B,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;IACZ,aAAa;IACb,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;;IAEE,sBAAsB;EACxB;AACF","sourcesContent":["/* Header */\n#claims-container .brand-name a,\n#claims-container a.link {\n  color: #464646;\n}\n\n#claims-container a.link:hover {\n  color: #949494;\n}\n\n#claims-container img {\n  color: blue;\n}\n\n/* Claims */\n#claims-container {\n  overflow: hidden;\n}\n#claims {\n  position: relative;\n  margin-top: 12vh;\n  border-top: 1px solid #808080;\n}\n\n#claims .intro {\n  padding: 2% 6%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n#claims .intro .title {\n  color: #464646;\n  font-family: 'Cinzel', serif;\n  font-size: 36px;\n  margin-bottom: 45px;\n  text-align: center;\n}\n\n#claims .intro img.claims-icon {\n  height: 85px;\n  margin-bottom: 60px;\n}\n\n#claims .intro .detail-container {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  justify-content: space-around;\n  margin-bottom: 60px;\n}\n\n/* break point smaller than 576*/\n#claims .intro .detail-container .img-container {\n  margin: 0 15px;\n  width: 440px;\n  height: 263px;\n  display: flex;\n}\n\n#claims .intro .detail-container .img-container.first {\n  background-image: url(/public/assets/icons/dots_right.png);\n  background-repeat: no-repeat;\n  background-size: 160px;\n  background-position-x: 100%;\n  align-items: flex-end;\n}\n\n#claims .intro .detail-container .img-container.second {\n  background-image: url(/public/assets/icons/dots_left.png);\n  background-repeat: no-repeat;\n  background-size: 160px;\n  align-items: flex-end;\n  justify-content: flex-end;\n}\n\n#claims .intro .detail-container .img-container img {\n  width: auto;\n  height: 230px;\n}\n\n#claims .intro .detail-container .description-container {\n  margin: 0 15px;\n  width: 440px;\n  display: flex;\n}\n\n#claims .intro .detail-container .description-container.second {\n  justify-content: flex-end;\n}\n\n#claims .intro .detail-container .description-container p {\n  margin: 30px 0;\n  font-style: italic;\n  font-size: 16px;\n  padding: 0 20px;\n  width: 380px;\n}\n\n#claims .intro .detail-container .description-container.second p {\n  text-align: end;\n}\n\n#claims .claims-market {\n  background-color: #f4f4f4;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n  padding: 6%;\n}\n\n#claims .claims-market .title {\n  color: #464646;\n  font-family: 'Cinzel', serif;\n  font-size: 36px;\n  margin-bottom: 45px;\n  text-align: center;\n}\n\n#claims .claims-market p {\n  width: 68%;\n  text-align: center;\n  line-height: 30px;\n  font-size: 16px;\n  margin-bottom: 30px;\n}\n\n#claims #default-btn {\n  margin-top: 15px;\n}\n\n@media (max-width: 500px) {\n  #claims .intro .detail-container .description-container {\n    margin: 0;\n  }\n  #claims .intro .detail-container .description-container p {\n    width: 100%;\n  }\n  #claims .intro .detail-container .img-container {\n    width: 315px;\n    height: 188px;\n    margin: 0;\n  }\n  #claims .intro .detail-container .img-container img {\n    height: 165px;\n  }\n  #claims .intro .detail-container .img-container.first,\n  #claims .intro .detail-container .img-container.second {\n    background-size: 120px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
